import React, { useState, useEffect, useRef } from 'react';
import { getGlobalData } from '../../api/strapi/utils';
import TopBar from './TopBar';
import MainNav from './MainNav';

const NewHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isTopBarHidden, setIsTopBarHidden] = useState(false);
  const [globalData, setGlobalData] = useState(null);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const isTopBarHiddenRef = { current: false };
    let cooldownTimer = null;
    const COOLDOWN_MS = 350;

    const startCooldown = () => {
      if (cooldownTimer) {
        clearTimeout(cooldownTimer);
      }
      cooldownTimer = setTimeout(() => {
        cooldownTimer = null;
      }, COOLDOWN_MS);
    };

    const handleScroll = () => {
      const currentY = window.scrollY;
      setIsScrolled(currentY > 50);

      if (cooldownTimer) {
        lastScrollY.current = currentY;
        return;
      }

      if (currentY > lastScrollY.current + 2 && currentY > 36) {
        if (!isTopBarHiddenRef.current) {
          isTopBarHiddenRef.current = true;
          setIsTopBarHidden(true);
          startCooldown();
        }
      } else if (currentY < lastScrollY.current - 2) {
        if (isTopBarHiddenRef.current) {
          isTopBarHiddenRef.current = false;
          setIsTopBarHidden(false);
          startCooldown();
        }
      }

      lastScrollY.current = currentY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (cooldownTimer) {
        clearTimeout(cooldownTimer);
      }
    };
  }, []);

  useEffect(() => {
    const fetchGlobalData = async () => {
      const result = await getGlobalData();
      if (!result.ok) {
        if (result.reason !== "NOT_FOUND") {
          console.warn("Header global data unavailable:", result);
        }
        setGlobalData(null);
        return;
      }

      setGlobalData(result.data?.attributes || result.data);
    };

    fetchGlobalData();
  }, []);

  return (
    <div className="sticky top-0 z-[50]">
      <TopBar globalData={globalData} hidden={isTopBarHidden} />
      <MainNav isScrolled={isScrolled} topBarHidden={isTopBarHidden} globalData={globalData} />
    </div>
  );
};

export default NewHeader;